import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
export default {
  name: 'ViewISFMTicketingAdd',
  data() {
    return {
      file: null,
      fileId: null,
      subjects: [{
        subjectId: 1,
        subjectText: this.$i18n_t('Common.dirty')
      }, {
        subjectId: 2,
        subjectText: this.$i18n_t('Common.failure')
      }, {
        subjectId: 3,
        subjectText: this.$i18n_t('Common.waterLeakage')
      }, {
        subjectId: 4,
        subjectText: this.$i18n_t('Common.powerFailure')
      }, {
        subjectId: 5,
        subjectText: this.$i18n_t('Common.heatingFailure')
      }, {
        subjectId: 6,
        subjectText: this.$i18n_t('Common.accessMgmt')
      }, {
        subjectId: 7,
        subjectText: this.$i18n_t('Common.other')
      }],
      buttonsMainForm: [{
        title: this.$i18n_t('Common.createTicket'),
        icon: 'fal fa-paper-plane',
        type: 'submit'
      }],
      types: [{
        id: 1,
        name: this.$i18n_t('Common.bug')
      }, {
        id: 2,
        name: this.$i18n_t('Common.report')
      }],
      formData: new FormData(),
      comment: null,
      type: null,
      selectedRoom: null,
      valid: false,
      loading: false,
      twinId: null,
      ticket: {
        subject: null,
        status: 0,
        date: new Date(),
        properties: {
          dTwin: null,
          fileId: null,
          imageRotate: 0
        },
        comments: [],
        type: {}
      },
      comments: {
        comment: null,
        type: 'test',
        date: new Date()
      },
      comboRules: [v => !!v || this.$i18n_t('Common.valueRequired')]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    formTitle() {
      return this.editedIndex === -1 ? 'New Record' : 'Edit Record';
    }
  },
  mounted() {
    this.$store.state.app.loading = false;
  },
  methods: {
    getFile(file) {
      this.formData = new FormData(); // Muss neu erzeugt werden gegen Duplikate
      this.file = file;
      this.formData.append('file', this.file);
    },
    validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.snackbar = true;
      }
    },
    save() {
      this.validate();
      if (this.valid && this.ticket.subject && this.ticket.properties.dTwin && this.type.name) {
        this.loading = true;
        let filePromise = Promise.resolve();
        if (this.file) {
          filePromise = this.saveFile();
        }
        filePromise.then(() => {
          return this.createTicket();
        }).catch(error => {
          console.error('Error during IS-FM ticket-creation process: ', error);
        }).finally(() => {
          this.loading = false;
          this.$store.state.app.loading = false;
        });
      }
    },
    saveFile() {
      return ApiService.saveFile(this, this.formData).then(result => {
        this.fileId = result.fileId;
        this.ticket.properties.fileId = result.fileId;
        this.$snack(this.$i18n_t('Common.fileSavedText'), 'success');
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.fileSavedFaild'), 'error');
        }
        throw error;
      });
    },
    createTicket() {
      // add comments to ticket
      if (this.comments.comment) {
        this.ticket.comments.push(this.comments);
      }
      // add type to ticket
      if (this.type.name) {
        this.ticket.type = {
          name: this.type.name
        };
      }
      this.ticket.subject = this.ticket.subject.subjectText;
      return ApiService.isFmTicketCreate(this, this.ticket).then(() => {
        this.clear();
        this.$snack(this.$i18n_t('Common.ticketCreatedText'), 'success');
        this.$router.push({
          path: '/fm-ticket-success'
        });
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.ticketCreatedFaild'), 'error');
        }
        throw error;
      });
    },
    clear() {
      this.ticket.properties.dTwin = null;
      this.ticket.subject = '';
      this.comments.comment = '';
      this.ticket.file = '';
      this.type = '';
      this.twinId = null;
      this.$refs.mediaUpload.clear();
    },
    dtwinSelected(dtwin) {
      this.twinId = dtwin.id;
      // only save the ID, the rest is fetched on runtime
      this.ticket.properties.dTwin = {
        id: dtwin.id
      };
      this.ticket.scopeId = dtwin.scopeId;
      this.ticket.tenantId = dtwin.tenantId;
    },
    rotateImage(val) {
      this.ticket.properties.imageRotate = val;
    }
  }
};